import { render } from "./EditStudent.vue?vue&type=template&id=416f171b&scoped=true"
import script from "./EditStudent.vue?vue&type=script&lang=js"
export * from "./EditStudent.vue?vue&type=script&lang=js"

import "./EditStudent.vue?vue&type=style&index=0&id=416f171b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416f171b"]])

export default __exports__